import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Paper
} from "@mui/material";
import { Navigate, useParams  } from "react-router-dom";
import UserService from "../services/user-service";

export default function ResetPasswordWithToken({ onReset }) {
  const params = useParams()
  const token = params.token;

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      setErrorMsg("Le password non coincidono.");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    var associationToReset={
      token: token,
      password: password
    }

    UserService.resetPasswordToken(associationToReset).then(
      response => {
        setStatus("success");
      },
      error => {
        setStatus("error");
        setErrorMsg( "Errore durante il reset della password.");
      }
    );

  };

  if (!token) {
    return (
      <Alert severity="error">Token non presente nell’URL.</Alert>
    );
  }

  return (
    <Paper sx={{ p: 4, maxWidth: 400, mx: "auto", mt: 6 }} elevation={3}>
      <Typography variant="h5" mb={2}>Imposta Nuova Password</Typography>

      {status === "success" ? (
        <Alert severity="success">
          Password aggiornata con successo! Ora puoi effettuare il login.
        </Alert>
      ) : (
        <form onSubmit={handleSubmit}>
          <TextField
            label="Nuova Password"
            fullWidth
            required
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <TextField
            label="Conferma Password"
            fullWidth
            required
            type="password"
            margin="normal"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />

          {status === "error" && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMsg}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            disabled={status === "loading"}
          >
            {status === "loading" ? <CircularProgress size={24} /> : "Aggiorna Password"}
          </Button>
        </form>
      )}
    </Paper>
  );
}